import React from "react"
import styled from "styled-components"

export default styled.ul`
  padding: 12px 0;
  margin-left: 30px;

  li {
    margin-bottom: 5px;
  }
`



// WEBPACK FOOTER //
// /opt/build/repo/src/components/UnorderedList.js